import React, { useState } from "react";

export default function InfoLegal() {
  const [open, setOpen] = useState(true);
  return (
    <div
      class="notification is-warning is-light"
      style={{
        position: "fixed",
        bottom: "0px",
        opacity: 0.7,
        display: open ? "" : "none",
      }}
    >
      <button class="delete" onClick={(evt) => setOpen(false)} />
      Los polígonos de inmuebles visualizados en nuestra base cartográfica
      catastral corresponden a inmuebles registrados e integrados en la
      Institución desde agosto del año 2013 hasta la fecha.{" "}
      <b>
        La inexistencia de polígonos registrados e integrados en nuestra base
        cartográfica no implica que no existan títulos de propiedad en los
        espacios no graficados.
      </b>
    </div>
  );
}
